<!-- 显示所有属性列表 win -->
<template>
    <div class="property">
        <h1>{{$t('integration.attribute_list')}}</h1>
        <Attribute :isShowEdit2="true"></Attribute>
    </div>
</template>

<script>
import Attribute from '@/pages/business/components/detail/Attribute.vue'
export default {
    components:{
        Attribute
    }
}
</script>

<style scoped lang="scss">
.property{
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    padding: 15px;
    h1 {
        font-size: 16px;
        font-weight: bold;
        text-align: center;
        border-bottom: 1px solid #ccc;
        padding-bottom: 15px;
        margin-bottom: 15px;
    }
}
</style>